import { render, staticRenderFns } from "./demo-req-remove-popup.html?vue&type=template&id=2b8f88d2&scoped=true&external"
import script from "./demo-req-remove-popup.js?vue&type=script&lang=js&external"
export * from "./demo-req-remove-popup.js?vue&type=script&lang=js&external"
import style0 from "./demo-req-remove-popup.scss?vue&type=style&index=0&id=2b8f88d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8f88d2",
  null
  
)

export default component.exports